module.exports = __webpack_public_path__ + "img/primary.6c14b828.png";